export default {
  assets: {
    assetModel: "Asset Model",
    assetTypes: "Asset Typen",
    asset: "Asset",
    assetName: "Asset Name",
    assetSerialNumber: "Asset Seriennummer",
    assetsPlural: "Assets",
    serialNo: "Seriennummer",
    assetLevel: "Asset Level",
    assetType: "Asset Type",
    tags: "Tags",
    modelDescription: "Model Beschreibung",
    assetDescription: "Asset Beschreibung",
    attribute: "Attribut",
    attributes: "Attribute",
  },
  assetTypes: {
    name: "Asset Typ",
    plural: "Asset Typen",
    columns: {
      id: "ID",
      assetTypeName: "Asset Typ Name",
      description: "Beschreibung",
      createdBy: "Erstellt von",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
      model: "Modell",
      models: "Modelle",
    },
    updateAssetType: {
      error: {
        title: "Asset Typ kann nicht {action} werden",
        message: "Dieser Asset Typ ist ein System Asset Typ und kann nicht {action} werden.",
      },
    },
  },
  assetModel: {
    name: "Asset Model",
    plural: "Asset Modelle",
    nameWithCount: "Modelle ({count})",
    columns: {
      id: "ID",
      assetModelName: "Asset Modell Name",
      description: "Beschreibung",
      createdBy: "Erstellt von",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
    },
  },
  assetAttributeSets: {
    name: "Asset Attribut Satz",
    plural: "Asset Attribut Sets",
    columns: {
      id: "ID",
      assetAttributeSetName: "Asset Attribute Satz Name",
      description: "Description",
      createdBy: "Erstellt von",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
      lastChangedAt: "Zuletzt geändert am",
    },
  },
  devices: {
    name: "Gerät",
    plural: "Geräte",
    deviceName: "Gerätename",
    deviceModel: "Gerät Modell",
    deviceType: "Gerätetyp",
    deviceTypeDetails: "Gerätetyp Details",
    device: "Gerät",
    devicesPlural: "Geräte",
    serialNo: "Software Seriennummer",
    hardwareSerialNo: "Hardware Seriennummer",
    deploymentGroup: "Deployment Group",
    noDeploymentGroup: "Keine Deployment Group",
    tags: "Tags",
    status: "Status",
    healthStatus: "Health Status",
    lastStoreActivity: "Letzte Store Aktivität",
    lastMessagingActivity: "Letzte Messaging Aktivität",
  },
  deviceModel: {
    name: "Gerät Modell",
    plural: "Gerät Modelle",
    columns: {
      id: "ID",
      modelName: "Modellname",
      description: "Beschreibung",
      createdBy: "Erstellt von",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
    },
  },
  edgeDevices: {
    name: "Edge Gerät",
    plural: "Edge Geräte",
    columns: {
      deviceName: "Gerätename",
      deviceSerial: "Geräte Seriennummer",
      deviceModel: "Gerät Modell",
      deviceArchitecture: "Geräte Architektur",
      deviceGatewayPublicKey: "Geräte Gateway Public Schlüssel",
      deviceLastActivity: "Letzte Aktivität",
      deviceModelRevision: "Gerät Modell Revision",
      manufacturer: "Hersteller",
      createdAt: "Erstellt am",
      createdBy: "Erstellt von",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
    },
  },
  user: {
    name: "Benutzer",
    plural: "Benutzer",
    columns: {
      id: "ID",
      userName: "Benutzer",
      userInformation: "Benutzerinformation",
      firstName: "Vorname",
      lastName: "Nachname",
      authenticationProvider: "Authentifizierungsanbieter",
      contact: "Kontakt",
      email: "Email",
      emailAdress: "E-Mail Adresse",
      tenant: "Mieter",
      registrationDate: "Registrierungsdatum",
      role: "Rolle",
      roles: "Rollen",
      registered: "Eingetragen",
      language: "Sprache",
      myProfile: "Mein Profil",
      userDescription: "Benutzerbeschreibung",
      lastLogin: "Letzte Anmeldung",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      isDeleted: "Gelöscht",
      displayName: "Anzeigename",
    },
  },
  tenant: {
    name: "Tenant",
    plural: "Tenants",
    columns: {
      id: "ID",
      tenantIdentifier: "Tenant ID",
      tenantName: "Tenant Name",
      isDeleted: "is deleted",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      tenantRole: "Tenant Rolle",
      tenantType: "Tenant Typ",
    },
  },
  role: {
    name: "Rolle",
    plural: "Rollen",
    columns: {
      id: "ID",
      name: "Name",
      description: "Beschreibung",
      isDeleted: "is deleted",
      createdAt: "Erstellt am",
      modifiedAt: "Geändert am",
      isDefaultRole: "ist Standardrolle",
    },
  },
  dataRangeSelector: {
    selectDateRange: "Zeitraum Auswählen",
    start: "Start",
    end: "Ende",
  },
  deploymentGroups: {
    name: "Bereitstellungsgruppe",
    plural: "Bereitstellungsgruppen",
    columns: {
      name: "Name",
      description: "Beschreibung",
      deviceModelRevision: "Gerätemodellrevision",
      autoUpdateMode: "Auto-Update-Modus",
      isDeltaUpdateOnly: "Nur Delta-Update",
      ownerUserId: "Besitzer-Benutzer-ID",
      deviceCount: "Anzahl der Geräte",
      updatedDeviceCount: "Anzahl aktualisierter Geräte",
      totalPendingActionCount: "Ausstehende Aktionen insgesamt",
      createdAt: "Erstellt am",
      createdBy: "Erstellt von",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
    },
  },
  apps: {
    name: "App",
    plural: "Apps",
    columns: {
      appName: "App Name",
      appDescription: "Description",
      appType: "Typ",
      appCategory: "Kategorie",
      appDeviceArchitecture: "Architektur",
      installedDevicesCount: "Installierte Geräte",
      version: "Version",
      rating: "Bewertung",
      installedDeviceCount: "Verwendung (Installiert auf Geräten)",
      createdAt: "Erstellt am",
      createdBy: "Erstellt von",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
      lastChangedAt: "Zuletzt geändert am",
      size: "Größe [MB]",
    },
  },
  software: {
    name: "App",
    plural: "Apps",
    columns: {
      name: "Name",
      softwareName: "Software Name",
      description: "Beschreibung",
      architecture: "Architektur",
      softwareDeviceArchitecture: "Architektur",
      version: "Version",
      rating: "Bewertung",
      installedDeviceCount: "Verwendung (Installiert auf Geräten)",
      createdAt: "Erstellt am",
      createdBy: "Erstellt von",
      lastChangedAt: "Zuletzt geändert am",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
      summary: "Zusammenfassung",
    },
    firmware: {
      noFirmwareAssigned: "Keine Firmware zugewiesen",
    },
    osImage: {
      noOSImageAssigned: "Kein OS-Image zugewiesen",
    },
  },
  softwareRevision: {
    name: "App Revision",
    plural: "App Revisionen",
    columns: {
      description: "Beschreibung",
      version: "Version",
      buildDateTime: "Build Datum & Uhrzeit",
      createdAt: "Erstellt am",
      createdBy: "Erstellt von",
      lastChangedAt: "Zuletzt geändert am",
      modifiedAt: "Geändert am",
      modifiedBy: "Geändert von",
      revision: "Revision",
      softwareObjectSize: "Größe [MB]",
    },
  },
};
